import { render, staticRenderFns } from "./serviceRecord.vue?vue&type=template&id=fea1c4e6&scoped=true"
import script from "./serviceRecord.vue?vue&type=script&lang=js"
export * from "./serviceRecord.vue?vue&type=script&lang=js"
import style0 from "./serviceRecord.vue?vue&type=style&index=0&id=fea1c4e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea1c4e6",
  null
  
)

export default component.exports